<template>
    <div class="pagination" v-if="totalPages > 1">
        <button type="button" class="pg-arrow" @click="changePage(currentPage - 1)" :disabled="currentPage <= 1">
            &larr;
        </button>

        <button type="button" v-for="page in totalPages" :key="page" :class="{ active: page === currentPage }"
            @click="changePage(page)">
            {{ page }}
        </button>

        <button type="button" class="pg-arrow" @click="changePage(currentPage + 1)"
            :disabled="currentPage >= totalPages">
            &rarr;
        </button>
    </div>
</template>

<script>
export default {
    props: {
        meta: {
            required: true,
            type: Object
        },
        modelValue: {
            required: true,
            type: Object
        },
    },
    emits: ['update:modelValue'],

    computed: {
        filters() {
            return this.modelValue;
        },
        currentPage() {
            return Number(this.filters.page) || 1;
        },
        totalPages() {
            const explicit = Number(this.meta.total_pages);
            if (explicit) return explicit;

            const total = Number(this.meta.total ?? this.meta.total_count);
            const pageSize = Number(this.filters.page_size) || Number(this.meta.page_size);
            if (total && pageSize) return Math.ceil(total / pageSize);

            return 0;
        }
    },

    methods: {
        changePage(pageNumber) {
            if (
                pageNumber >= 1 &&
                pageNumber <= this.totalPages &&
                pageNumber !== this.currentPage
            ) {
                this.$emit('update:modelValue', {
                    ...this.filters,
                    page: pageNumber
                });

                if (typeof window !== 'undefined') {
                    const toolbar = document.querySelector('.blog-toolbar');
                    if (toolbar) {
                        window.scrollTo({
                            top: toolbar.getBoundingClientRect().top + window.scrollY - 110,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        }
    }
}
</script>
